import { createSelector } from 'reselect';

export const GetProfile = (state) => state.user.profile;

export const GetBalance = createSelector(GetProfile, (profile) => profile?.balance);

export const GetTerminalBalance = (state) => state.terminal.balance?.session_balance;

export const GetToken = (state) => state.terminal.authData.token;

export const GetUser = (state) => state.user;

export const GetUserId = (state) => state.user.authData?.user_id || state.user.profile?.id;
